import { AppRouter } from './routes/AppRouter';

/**
 * The console is its routes (`CR-006`). What it used to render moved into `features/dashboard`.
 */
export function App(): React.JSX.Element {
  return <AppRouter />;
}
